export default {
  init(components) {
    components.get('search-filters').on('change', function(input) {
      // input is the changed input...
    });
  },
};
